// Copyright (c) 2017 Deere & Company

import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import t from 'tcomb';

const SpecialAllowancePartialDebit = t.struct({
    changedCompanyContribution: t.maybe(t.Number),
    companyContribution: t.maybe(t.Number),
    currency: KeyValuePair,
    customerContribution: t.maybe(t.Number),
    dealerContribution: t.maybe(t.Number)
}, {
    name: 'SpecialAllowancePartialDebit',
    strict: true
});

export const getDefaultState = () => new SpecialAllowancePartialDebit({
    changedCompanyContribution: null,
    companyContribution: null,
    currency: getKeyValuePairDefaultState(),
    customerContribution: null,
    dealerContribution: null
});

export default SpecialAllowancePartialDebit;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/special-allowance-partial-debit.js